import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { GiHamburgerMenu } from "react-icons/gi";
import { IoMdArrowDropright } from "react-icons/io";
import { BsTruck } from "react-icons/bs";
import { Drawer, Dropdown } from "antd";
import { AiOutlineHeart, AiOutlineShoppingCart } from "react-icons/ai";
import { ImProfile } from "react-icons/im";
import { TbPackage } from "react-icons/tb";
import { RiUserSharedFill } from "react-icons/ri";
import { FiArrowUpLeft } from "react-icons/fi";
import { CgProfile } from "react-icons/cg";
import { GoPrimitiveDot } from "react-icons/go";
import { HiOutlineWrenchScrewdriver } from "react-icons/hi2";

const NavbarTop = ({
  isLogin,
  setIsLogin,
  cartCount,
  wishlistCount,
  setLoginModal,
}) => {
  const [open, setOpen] = useState(false);
  const divRef = useRef(null);
  let Navigate = useNavigate();

  const showDrawer = () => {
    setOpen(true);
  };
  const onClose = () => {
    setOpen(false);
  };

  const [data, setData] = useState([]);

  const getAllCategory = () => {
    var requestOptions = {
      method: "GET",
      redirect: "follow",
      /* headers: new Headers({
        'Authorization': 'basic babbabbdffsdjf',
      }), */
    };
    fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "admin/getHomeZoneAppliances",
      // "/admin/getHomeZoneAppliances",
      requestOptions,
    )
      .then((response) => response.json())
      .then((result) => {
        console.log('homezone appliances', result);
        setData(result.data);
      })
      .catch((error) => console.log("error", error));
  };

  useEffect(() => {
    getAllCategory();
    function handleClickOutside(event) {
      if (divRef.current && !divRef.current.contains(event.target)) {
        // Handle click outside logic here
        setSearchMenu(false);
      }
    }

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  // const [loginModal, setLoginModal] = useState(false);
  const [showLogin, setShowLogin] = useState(true);

  const handleRegister = () => {
    setShowLogin(false);
  };

  const handleLogin = () => {
    setShowLogin(true);
  };

  let customerName = localStorage.getItem("CN");

  const handleLogout = () => {
    localStorage.removeItem("CID");
    localStorage.removeItem("CN");
    localStorage.removeItem("token");
    localStorage.removeItem("rzp_device_id");
    localStorage.removeItem("rzp_checkout_anon_id");
    localStorage.removeItem("rzp_checkout_user_id");
    setIsLogin(false);
    setTimeout(() => {
      Navigate("/");
    }, 1000);
  };

  const items = [
    {
      key: "1",
      label: (
        <Link
          to="/update-profile"
          className="p-1 flex items-center gap-3 font-semibold text-black"
        >
          <ImProfile />
          Your Profile
        </Link>
      ),
    },
    {
      key: "2",
      label: (
        <Link
          to="/recent-orders"
          className="p-1 flex items-center gap-3 font-semibold text-black"
        >
          <TbPackage />
          Your Orders
        </Link>
      ),
    },
    {
      key: "4",
      danger: true,
      label: (
        <button className="p-1 flex items-center gap-3" onClick={handleLogout}>
          <RiUserSharedFill className="text-black" size={20} />
          <p className="text-sm font-semibold text-md">Logout</p>
        </button>
      ),
    },
  ];
  const [searchValue, setSearchValue] = useState("");
  const [SearchMenu, setSearchMenu] = useState(false);

  // const GoToSearchPage = (e) => {
  //   e.preventDefault();
  //   Navigate(`/search/${searchValue}`);
  // };

  const [ProductsResult, setProductsResult] = useState([]);
  const [CategoryResult, setCategoryResult] = useState([]);
  const [SubCategoryResult, setSubCategoryResult] = useState([]);
  const [maxIndex, setMaxIndex] = useState();

  const handleOnChange = async (e) => {
    setSearchValue(e.target.value);
    var value = e.target.value;
    if (value.length > 0) {
      setSearchMenu(true);
    }
    if (value.length === 1) {
      setSearchMenu(false);
    }
    var myHeaders = new Headers();
    myHeaders.append("Content-Type", "application/json");

    var raw = JSON.stringify({
      search: searchValue,
    });

    var requestOptions = {
      method: "POST",
      headers: myHeaders,
      body: raw,
      redirect: "follow",
    };

    await fetch(
      process.env.REACT_APP_HAPS_MEDIA_BASE_URL + "product/getSearchAll",
      requestOptions
    )
      .then((response) => response.json())
      .then((result) => {
        // console.log(result);
        setProductsResult(result.products);
        setCategoryResult(result.homeZoneAppliances);
        setSubCategoryResult(result.homeZoneCategory);
        setMaxIndex(result.products.length);
      })
      .catch((error) => console.log("error", error));
  };

  const [selectedIndex, setSelectedIndex] = useState(-1);

  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "ArrowDown") {
        setSelectedIndex((prevIndex) => Math.min(prevIndex + 1, maxIndex));
      } else if (event.key === "ArrowUp") {
        setSelectedIndex((prevIndex) => Math.max(prevIndex - 1, -1));
      } else if (event.key === "Enter") {
        if (selectedIndex >= 0) {
          // Handle item selection and search here
          const selectedResult = CategoryResult[selectedIndex]; // Update with your data source
          setSearchValue(selectedResult.title);
          // Perform the search or navigation action here
        }
      }
    };

    document.addEventListener("keydown", handleKeyDown);

    return () => {
      document.removeEventListener("keydown", handleKeyDown);
    };
  }, [selectedIndex, maxIndex]);

  return (
    <nav className="relative bg-white">
      <div className="mx-2 md:mx-2 lg:mx-2 xl:mx-10 2xl:mx-14">
        <div className="py-1 md:py-3 grid grid-cols-6 items-center gap-4">
          {/* Logo */}
          <div className="col-start-1 col-span-5 md:col-span-2 lg:col-span-2">
            {/* <Link
              to=""
              className="navName text-2xl md:text-2xl lg:text-2xl xl:lg:text-3xl font-serif font-[500] uppercase mt-2"
              onClick={() => window.scroll(0, 0)}
            >
              Fina Interior
            </Link> */}
            <Link to="/" className="relative md:absolute lg:absolute top-1">
              <img
                src="/green-logo.png"
                className="w-[56px] h-[56px] md:w-[80px] md:h-[60px] object-cover"
                alt="Fina Interior Logo"
              />
            </Link>
          </div>
          {/* Search */}
          <div className="hidden md:hidden lg:block col-start-3 col-span-3">
            <form
              className="w-full relative"
            // onSubmit={GoToSearchPage}
            >
              <div>
                <label
                  htmlFor="default-search"
                  className="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white"
                >
                  Search
                </label>
                <div className="relative">
                  <button className="absolute inset-y-0 right-3 flex items-center pl-3 ">
                    <svg
                      aria-hidden="true"
                      className="w-5 h-5 text-gray-500 dark:text-gray-400"
                      fill="none"
                      stroke="currentColor"
                      viewBox="0 0 24 24"
                      xmlns="http://www.w3.org/2000/svg"
                    >
                      <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                      />
                    </svg>
                  </button>
                  <input
                    type="text"
                    id="default-search"
                    className="block w-full p-2 pl-3 text-sm text-[#027100] font-semibold border border-gray-500 rounded-lg md:rounded-lg lg:rounded-2xl xl:rounded-2xl bg-gray-50 focus:outline-none"
                    placeholder="Search Sofa, Rug, Center Table..."
                    value={searchValue}
                    onChange={handleOnChange}
                    // onBlur={() => setSearchMenu(false)}
                    required
                    autoComplete="off"
                  />
                </div>
              </div>
              {SearchMenu && (
                <div
                  className="absolute z-[999999] top-10 w-full shadow-2xl error-message"
                  ref={divRef}
                >
                  <div className="bg-white h-96 rounded-2xl border-t border-gray-200 overflow-scroll">
                    <div className="p-2 text-sm flex flex-col gap-0.5">
                      {CategoryResult &&
                        CategoryResult.map((el, i) => {
                          return (
                            <button
                              onClick={() => {
                                setSearchValue(
                                  el.title
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")
                                );
                                Navigate(`/sub-category/${el.slug}`);
                                setSearchMenu(false);
                              }}
                              className={`${selectedIndex === i ? "bg-gray-200" : ""
                                } flex items-center justify-between`}
                              key={i}
                            >
                              <div className="flex items-center gap-2 md:gap-4 rounded-md p-2 hover:bg-gray-200 transition-all ease-in-out duration-500 cursor-pointer w-full">
                                <svg
                                  aria-hidden="true"
                                  className="w-5 h-5 text-gray-500 dark:text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                  />
                                </svg>
                                <div>
                                  <p className="font-bold tracking-wide capitalize text-sm text-start">
                                    {el.title
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}
                                  </p>
                                  <p className="text-xs text-gray-600 font-semibold">
                                    In Category
                                  </p>
                                </div>
                              </div>
                              <button onClick={() => setSearchValue("el.name")}>
                                <FiArrowUpLeft
                                  size={25}
                                  className="text-gray-500 mr-1"
                                />
                              </button>
                            </button>
                          );
                        })}
                      {CategoryResult && <hr className="mx-2" />}
                      {SubCategoryResult &&
                        SubCategoryResult.map((el, i) => {
                          return (
                            <button
                              onClick={() => {
                                setSearchValue(
                                  el.title
                                    .toLowerCase()
                                    .split(" ")
                                    .map(
                                      (word) =>
                                        word.charAt(0).toUpperCase() +
                                        word.slice(1)
                                    )
                                    .join(" ")
                                );
                                Navigate(`/category/${el.slug}`);
                                setSearchMenu(false);
                              }}
                              className="flex items-center justify-between"
                              key={i}
                            >
                              <div className="flex items-center gap-2 md:gap-4 rounded-md p-2 hover:bg-gray-200 transition-all ease-in-out duration-500 cursor-pointer w-full">
                                <svg
                                  aria-hidden="true"
                                  className="w-5 h-5 text-gray-500 dark:text-gray-400"
                                  fill="none"
                                  stroke="currentColor"
                                  viewBox="0 0 24 24"
                                  xmlns="http://www.w3.org/2000/svg"
                                >
                                  <path
                                    strokeLinecap="round"
                                    strokeLinejoin="round"
                                    strokeWidth={2}
                                    d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                  />
                                </svg>
                                <div>
                                  <p className="font-bold tracking-wide capitalize text-sm text-start">
                                    {el.title
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}
                                  </p>
                                  <p className="text-xs text-gray-600 font-semibold text-start">
                                    In{" "}
                                    {el.category_title
                                      .toLowerCase()
                                      .split(" ")
                                      .map(
                                        (word) =>
                                          word.charAt(0).toUpperCase() +
                                          word.slice(1)
                                      )
                                      .join(" ")}
                                  </p>
                                </div>
                              </div>
                              <button onClick={() => setSearchValue("el.name")}>
                                <FiArrowUpLeft
                                  size={25}
                                  className="text-gray-500 mr-1"
                                />
                              </button>
                            </button>
                          );
                        })}
                      {SubCategoryResult && <hr className="mx-2" />}
                      {ProductsResult &&
                        ProductsResult.slice(0, 5).map((el, i) => {
                          return (
                            <button
                              onClick={() => {
                                setSearchValue(el.name);
                                setSearchMenu(false);
                                Navigate(`/single-product/${el.id}`);
                              }}
                              className="flex items-center justify-between"
                              key={i}
                            >
                              <div className="flex items-center gap-2 md:gap-4 rounded-md p-2 hover:bg-gray-200 transition-all ease-in-out duration-500 cursor-pointer w-full">
                                <img
                                  src={
                                    process.env.REACT_APP_HAPS_MEDIA_BASE_URL +
                                    el.image
                                  }
                                  className="w-8 h-8 object-cover rounded-md"
                                  alt="Image Not Found"
                                />
                                <div>
                                  <p className="font-bold tracking-wide">
                                    {el.name}
                                  </p>
                                  <p className="text-xs text-gray-600 font-semibold text-start">
                                    View product
                                  </p>
                                </div>
                              </div>
                              <button>
                                <FiArrowUpLeft
                                  size={25}
                                  className="text-gray-500 mr-1"
                                />
                              </button>
                            </button>
                          );
                        })}
                    </div>
                  </div>
                </div>
              )}
            </form>
          </div>
          {/* Right Links */}
          <div className="hidden md:block lg:block xl:block col col-start-7">
            <div className="flex justify-end gap-5 ml-2 items-center">
              {/* <div className="">
                <div className="flex justify-center">
                  <button
                    onClick={() => window.open("https://arrangefree.com/backend/public/uploads/Arrange_free.pdf", "_blank")}
                    className="bg-[#FFE342] text-[#000] font-bold font-sans text-sm md:text-base py-2 px-6 rounded-lg hover:text-[#027100] transition duration-300"
                  >
                    Fina Interior Brochures
                  </button>
                </div>
              </div> */}
              <Link
                to="/fina-interior-home+interior+services"
                className="flex flex-col items-center relative"
              >
                <HiOutlineWrenchScrewdriver
                  size={25}
                  className="text-[#027100]"
                />
                <p className="text-xs font-semibold text-[#000] tracking-widest">
                  Interior Services
                </p>
              </Link>
              <Link
                to="/track-your-order"
                className="flex flex-col items-center relative"
              >
                <BsTruck className="text-[#027100]" size={25} />
                <figcaption className="text-xs font-semibold text-[#000] tracking-widest text-center">
                  Track Order
                </figcaption>
              </Link>
              {isLogin === true ? (
                <Link
                  to="/cart"
                  className="flex flex-col items-center relative"
                >
                  <AiOutlineShoppingCart className="text-gray-600" size={25} />
                  <GoPrimitiveDot
                    className="text-red-600 absolute left-2.5 -top-[7px]"
                    size={25}
                  />
                  <p className="text-[10px] font-semibold absolute text-white right-[3px] -top-0.5">
                    {cartCount}
                  </p>
                  <figcaption className="text-xs font-semibold text-black tracking-widest text-center">
                    cart
                  </figcaption>
                </Link>
              ) : (
                <button
                  onClick={() => setLoginModal(true)}
                  className="flex flex-col items-center"
                >
                  <AiOutlineShoppingCart className="text-gray-600" size={25} />
                  <figcaption className="text-xs font-semibold text-black tracking-widest text-center">
                    cart
                  </figcaption>
                </button>
              )}
              {isLogin === true ? (
                <Link
                  to="/wishlist"
                  className="flex flex-col items-center relative"
                >
                  <AiOutlineHeart className="text-gray-600" size={25} />
                  <GoPrimitiveDot
                    className="text-red-600 absolute right-1 -top-[7px]"
                    size={25}
                  />
                  <p className="text-[10px] font-semibold absolute text-white right-[12.5px] -top-0.5">
                    {wishlistCount}
                  </p>
                  <figcaption className="text-xs font-semibold text-black tracking-widest">
                    wishlist
                  </figcaption>
                </Link>
              ) : (
                <button
                  onClick={() => setLoginModal(true)}
                  className="flex flex-col items-center"
                >
                  <AiOutlineHeart className="text-gray-600" size={25} />
                  <figcaption className="text-xs font-semibold text-black tracking-widest">
                    wishlist
                  </figcaption>
                </button>
              )}
              {isLogin === true ? (
                <div className="flex items-center gap-3">
                  <Dropdown
                    menu={{
                      items,
                    }}
                    className="cursor-pointer"
                    placement="bottom"
                  >
                    <a onClick={(e) => e.preventDefault()}>
                      <div className="text-sm flex flex-col items-center relative">
                        <div className="w-7 h-7 rounded-full text-white bg-[#FFE342]" />
                        <p className="text-[20px] font-bold text-center absolute top-1 text-[#027100]">
                          {customerName.length > 0
                            ? customerName.slice(0, 1)
                            : "P"}
                        </p>
                        <figcaption className="text-xs font-semibold text-center text-black tracking-widest">
                          profile
                        </figcaption>
                      </div>
                    </a>
                  </Dropdown>
                  {/* </Link> */}
                </div>
              ) : (
                <button
                  onClick={() => setLoginModal(true)}
                  className="flex flex-col items-center"
                >
                  <CgProfile className="text-gray-600" size={25} />
                  <figcaption className="text-xs font-semibold text-center text-black tracking-widest">
                    profile
                  </figcaption>
                </button>
              )}
            </div>
          </div>
          {/* Hamburger Menu */}
          <div className="block md:block lg:hidden xl:hidden">
            <div className="flex justify-end items-center">
              {/* Interior Services Link */}
              {/* <div className="flex flex-col items-center relative mr-2">
                <div className="flex justify-center">
                <p className="text-xs font-semibold text-[#000] tracking-widest">
                  Brochures
                  </p>
                </div>
              </div>
              <Link
                to="/fina-interior-home+interior+services"
                className="flex flex-col items-center relative mr-2"
              >
                <HiOutlineWrenchScrewdriver
                  size={25}
                  className="text-[#027100]"
                />
                <p className="text-xs font-semibold text-[#000] tracking-widest">
                  Interior Services
                </p>
              </Link> */}
              {/* Hamburger Menu Button */}
              <button onClick={showDrawer}>
                <GiHamburgerMenu size={25} />
              </button>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        title={<div className="drawer-title">Fina Interior</div>}
        placement="right"
        onClose={onClose}
        open={open}
        width={300}
      >
        <div>
          {data &&
            data.map((el, i) => {
              return (
                <div key={i}>
                  <button
                    onClick={() => {
                      Navigate(`/sub-category/${el.slug}`);
                      setOpen(false);
                    }}
                    className="py-2 flex justify-between items-center cursor-pointer hover:bg-gray-100 w-full"
                  >
                    <img
                      src={process.env.REACT_APP_HAPS_MEDIA_BASE_URL + el.image}
                      alt=""
                      className="w-8 h-8 rounded-full object-cover"
                    />
                    <li className="font-semibold text-sm text-black list-none">
                      {el.title}
                    </li>
                    <IoMdArrowDropright />
                  </button>
                  <hr className="border-t-[0.5px] border-black" />
                </div>
              );
            })}
          <div className="mt-5 flex flex-col gap-2">
            <button
              onClick={() => {
                Navigate("/recent-orders");
                setOpen(false);
              }}
              className="text-sm font-semibold text-black tracking-widest"
            >
              My Orders
            </button>
          </div>
        </div>
      </Drawer>
    </nav>
  );
};

export default NavbarTop;
